import React from 'react';
import { Accordion } from '@mantine/core';

import ProcurementExecutiveCard from './ProcurementExecutiveCard';
import { ProcurementExecutive } from '../../codegen/graphql';

type Props = {
    executives: ProcurementExecutive[];
};

function ProcurementExecutives({ executives }: Props) {
    return (
        <Accordion
            multiple
            classNames={{
                control: 'bg-primary-light',
                label: 'font-bold',
                content: 'px-1',
                item: 'border-none',
            }}
        >
            {executives?.length ? (
                executives.map(executive => (
                    <ProcurementExecutiveCard
                        key={executive.id}
                        executive={executive}
                    />
                ))
            ) : (
                <div className="flex items-center justify-center">
                    <p className="font-medium">
                        No Procurement Executives Found
                    </p>
                </div>
            )}
        </Accordion>
    );
}

export default ProcurementExecutives;
